<template>
  <div id="modal-info-body">
    <h2 style="text-align: center">Última sincronização</h2>
    <p>
      Na tabela apresentada em
      <strong>INÍCIO >> Administração >> Última sincronização</strong> tem:
      <strong>Descrição</strong> (tipos de fichas que o sincronizador analisou
      no e-SUS PEC ou Centralizador), <strong>Último registro</strong> (data do
      último registro que está no e-SUS PEC ou Centralizador) e
      <strong>Sincronização</strong> (data em que os dados foram processados e
      estão disponíveis para Monitoramento e Avaliação). A data de sincronização
      deve ser o mais próximo de hoje possível.
    </p>
    <h3>ATENÇÃO</h3>
    <p>
      Se tem registro do e-SUS PEC ou Centralizador municipal posterior a dada
      de Sincronização (Fonte) apresentada aqui, então entrar em contato com o
      Administrador municipal do e-SUS para verificação se aconteceu com sucesso
      o envio de dados para o SISAB e processamento dos relatórios e com o nosso
      suporte para verificação da sincronização.
    </p>
    <br />
    <p>
      Os dados aqui do sistema de Monitoramento e Avaliação na APS (M & A na
      APS) tem como fonte o e-SUS PEC ou Centralizador municipal. O
      Centralizador municipal dos dados do e-SUS é mais utilizado quando o
      município usa um sistema próprio ou sistema privado de Prontuário
      Eletrônico do Cidadão.
    </p>
    <h3>ATENÇÃO</h3>
    <p>
      No e-SUS PEC ou Centralizador municipal, faz-se necessário a verificação
      constante (semanalmente):
    </p>

    <ul>
      <li>
        Pelo login de Administrador municipal, na tela de acesso como
        <strong>Administrador municipal >> Transmissão de dados</strong> se os
        lotes gerados para envio estão com a
        <strong>situação de envio</strong> marcado como
        <strong>enviado</strong>.
      </li>
      <li>
        Como o login de Administrador da Instalação, na tela
        <strong>Instalador >> Relatórios >> Processamento</strong>, verificar em
        <strong>Disponibilidade dos relatórios</strong> (Produção, Consolidados
        e Operacionais) se estão <strong>disponíveis</strong> e em
        <strong>Processos</strong>, verificar quando o processamento foi
        concluído com sucesso (o ideal é o mais perto do hoje possível).
      </li>
    </ul>
    <br />
    <p>
      A transmissão de dados para o SISAB e o processamento de dados para os
      relatórios internos são importantíssimos para garantir que o e-SUS PEC ou
      Centralizador está funcionando perfeitamente e com isso, o sistema está em
      dias para a realização do Monitoramento e Avaliação na APS.
    </p>
    <br />
    <p>
      Quando existir uma falha, dentro do e-SUS PEC ou Centralizador, seja no
      envio de dados para o SISAB, seja no processamento e disponibilidade dos
      relatórios, então o Administrador municipal do e-SUS deve entrar em
      contato com o <a href="https://esusaps.freshdesk.com/support/login" target="_blank">laboratório bridge</a> informando a situação para que a correção
      seja aplicada e o problema resolvido.
    </p>
    <br />
    <p>
      Aqui no sistema de M & A na APS, se você notar que existe uma diferença
      entre os dados produzidos e as informações disponíveis, então é importante
      a realização da verificação do envio de dados para o SISAB e processamento
      dos relatórios no e-SUS PEC ou Centralizador, estado tudo certo, então
      entrar em contato com o nosso suporte para verificarmos por que a
      sincronização está atrasada.
    </p>
  </div>
</template>
<script>
export default {
  name: 'DocRessincronizacao',
}
</script>
<style scoped>
#modal-info {
  flex: 0 1 33%;
}

#modal-info button {
  width: 35px;
  height: 35px;
  border-radius: 32px;
  display: inline-block;
  background-color: #0fafd7;
  color: #fff;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  margin-top: 0;
  float: right;
}

#modal-info-body h2 {
  font-size: 18px;
  text-align: center;
  font-weight: bold;
}
#modal-info-body .notas-tecnicas {
  text-align: start;
  border-bottom: 1px solid #c1c1c1;
}
#modal-info-body h3 {
  font-size: 14px;
  font-weight: bold;
  margin: 20px 0;
}

#modal-info-body p {
  font-size: 14px;
  text-align: justify;
  margin-bottom: 0;
}

#modal-info-body ul {
  margin: 10px 25px 10px 25px;
  list-style-type: disc;
}

#modal-info-body ul li {
  font-size: 14px;
}

.modal-info-accessibility ul {
  display: inline-flex;
  margin: 10px 0 !important;
  padding: 0;
  gap: 5px;
}

.modal-info-accessibility ul li {
  border: 1px solid;
  list-style-type: none;
  padding: 5px;
  width: 30px;
  text-align: center;
  background-color: #6c757d;
  border-color: #6c757d;
  border-radius: 3px;
}

.modal-info-accessibility ul li a {
  color: #fff;
  font-size: 14px;
}

.modal-info-accessibility ul li a:hover {
  color: #000;
}
</style>
